import { gql } from "@apollo/client";

export const GET_TOOL_URL = gql`
  query ToolUrlByName($name: String!) {
    toolUrlByName(name: $name) {
      name
      url
    }
  }
`;
